import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "Defining Objectives & Requirements",
    description:
      "Together, we establish clear goals for your NLP solution: enhancing customer service, automating content analysis, or extracting insights from text data. We identify key requirements, discuss supported languages, data volume, and specific needs, both organizational and technical.",
    count: "01",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Data Collection & Preparation",
    description:
      "We gather and preprocess relevant data, ensuring high quality and consistency. This involves data cleaning, normalization, and annotation to build a robust foundation for your NLP solution.",
    count: "02",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Model Selection & Training",
    description:
      "Choosing the right models and algorithms is crucial. We select state-of-the-art NLP models and train them on your data, optimizing for accuracy and performance.",
    count: "03",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Development & Integration",
    description:
      "Our team develops and integrates the NLP solution into your existing systems, ensuring seamless operation and compatibility with your business processes and IT infrastructure.",
    count: "04",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Testing & Evaluation",
    description:
      "We rigorously test the NLP solution to ensure it meets performance and accuracy standards. Evaluation includes real-world scenario testing to validate results and refine the model as needed.",
    count: "05",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Deployment",
    description:
      "We deploy the NLP solution, providing full support to ensure a smooth launch. Our deployment process is designed to minimize disruption and maximize immediate benefits.",
    count: "06",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Maintenance & Support",
    description:
      "Post-deployment, we offer continuous maintenance and support to keep your NLP solution running optimally. We monitor performance, handle updates, and provide technical assistance as needed.",
    count: "07",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Continuous Improvement",
    description:
      "We believe in constant evolution. We collect feedback, monitor performance metrics, and implement improvements to keep your NLP solution ahead of the curve.",
    count: "08",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow p-100 nlp_process_flow"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our End-to-End <span>NLP Solution Development Process</span>
            </h2>
            <p>
              Transform your business with precise, efficient NLP solutions
              build with advanced technologies and refined development workflow
              for actionable insights and operational excellence.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
